document.addEventListener('DOMContentLoaded', function () {
    const signinUrl = '';
    const waterPumpUrl = '';
    const credentials = {
        "Email": "",
        "Password": ""
    };

    const fetchAccessToken = async () => {
        try {
            const response = await fetch(signinUrl, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(credentials)
            });
            if (response.ok) {
                const data = await response.json();
                return data.accessToken;
            } else {
                console.error('Failed to sign in:', response.status);
                return null;
            }
        } catch (error) {
            console.error('Error fetching access token:', error);
            return null;
        }
    };

    const fetchWaterPumpData = async (token) => {
        try {

            const response = await fetch(waterPumpUrl, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            if (response.ok) {
                const data = await response.json();
                if (data && data.length > 0) {
                    const latestData = data[data.length - 1];
                    const totalWaterPump = latestData.totalWaterPump;
                    const waterServings = Math.round(totalWaterPump / 0.24);
                    const plasticBottlesSaved = Math.round(totalWaterPump / 0.5);
                    const litersDonated = totalWaterPump;

                    const counterElement = document.getElementById('plastic-bottles-saved-counter');
                    if (counterElement) {
                        counterElement.setAttribute('data-countsTwo', plasticBottlesSaved);
                        countUpTwo(counterElement);
                    }
                    const counterElement2 = document.getElementById('water-servings-counter');
                    if (counterElement2) {
                        counterElement2.setAttribute('data-countone', waterServings);
                        countUpOne(counterElement2);
                    }

                    const waterServingsElement = document.getElementById('water-servings');
                    if (waterServingsElement) {
                        waterServingsElement.innerText = waterServings.toLocaleString();
                    }

                    const plasticBottlesSavedElement = document.getElementById('plastic-bottles-saved');
                    if (plasticBottlesSavedElement) {
                        plasticBottlesSavedElement.innerText = plasticBottlesSaved.toLocaleString();
                    }

                    const litersDonatedElement = document.getElementById('liters-donated');
                    if (litersDonatedElement) {
                        litersDonatedElement.innerText = litersDonated.toLocaleString();
                    }
                }
            } else {
                console.error('Failed to fetch water pump data:', response.status);
            }
        } catch (error) {
            console.error('Error fetching water pump data:', error);
        }
    };

    const main = async () => {
        const token = await fetchAccessToken();
        if (token) {
            fetchWaterPumpData(token);
        }
    };

    main();
});
